module.exports = __webpack_public_path__ + "static/route41roadhouse-ba557e32be9206d160b6b32cdd4f36f6.svg";